.discord-embed .discord-embed-field {
	min-width: 100%;
	margin-top: 5px;
}

.discord-embed .discord-embed-field.discord-inline-field {
	flex-grow: 1;
	flex-basis: auto;
	min-width: 100px;
}

.discord-embed .discord-embed-field .discord-field-title {
	color: #72767d;
	font-weight: 500;
	margin-bottom: 2px;
}

.discord-light-theme .discord-embed .discord-embed-field .discord-field-title {
	color: #747f8d;
}
